import { Button } from "antd";
import { Card } from "./widgets/ReportCard";
import { GenericBadge } from "../../dataInputs/tiers/components";
import FinancialData from "../../../components/common/FinancialData";
import { useApplicationReport } from "../hooks";

export const ApplicationReportCard: React.FC<{ applicationUUID: string, locationUUID?: string }> = ({ applicationUUID, locationUUID }) => {
  const { Block, Header, Content } = Card; 
  const { data, loading } = useApplicationReport(applicationUUID, locationUUID);
  const { drpReport, revenueSupported, businessFunctionsSupported, processAreasSupported, qualitativeFactorsSupported } = data || {};
  const drpInPlace = drpReport?.drpInPlace ? <GenericBadge name="Yes" color="#008000" /> : <GenericBadge name="No" color="#FF0000" />;
  return (
    <Card>
        <Block>
          <Header title="DRP Status" tooltip="Check if this Application has a DRP setup linked." />
          <Content isLoading={loading} className="flex flex-col gap-7 items-center justify-end px-6">
            <div className="flex items-center justify-between w-full">
                <span>DRP in place?</span>
                <span>
                    {drpInPlace}
                </span>
            </div>
            <div className="flex items-center justify-between w-full">
                <span>DRP Link:</span>
                <span>
                    <Button type="link" className="!pr-0" href={drpReport?.drpLink || '#'}>
                        DRP File Link
                    </Button>
                </span>
            </div>
          </Content>
        </Block>
        <Block>
          <Header title="Revenue Supported" tooltip="Total amount of revenue this Application is tied to." />
          <Content isLoading={loading} className="flex flex-col gap-7 items-center justify-end px-6">
            <span className="text-3xl text-left font-bold w-full">
                <FinancialData text={revenueSupported || 0} />
            </span>
            <span className="text-[14px] text-left w-full">
                Amount supported
            </span>
          </Content>
        </Block>
        <Block>
          <Header title="Business Functions Supported" tooltip="Total number of Business Functions this Application is tied to." />
          <Content isLoading={loading} className="flex flex-col items-center justify-end px-6 gap-2.5">
            <span className="text-3xl text-left font-bold w-full">
                <span className="text-3xl font-bold">
                    {businessFunctionsSupported?.supported}
                </span> <span className="text-xl font-normal">/ {businessFunctionsSupported?.total}</span>
            </span>
            <span className="text-[14px] text-left w-full">
                BFs that this Application supports
            </span>
          </Content>
        </Block>
        <Block>
          <Header title="Qualitative Factors Supported" tooltip="Total number of Qualitative Factors this Application is tied to." />
          <Content isLoading={loading} className="flex flex-col items-center justify-end px-6 gap-2.5">
            <span className="text-3xl text-left font-bold w-full">
                <span className="text-3xl font-bold">
                    {qualitativeFactorsSupported?.supported}
                </span> <span className="text-xl font-normal">/ {qualitativeFactorsSupported?.total}</span>
            </span>
            <span className="text-[14px] text-left w-full">
                QFs that this Application supports
            </span>
          </Content>
        </Block>
        {processAreasSupported && (
          <Block>
            <Header title="Process Areas Supported" tooltip="Total number of Process Areas this Application is tied to." />
            <Content isLoading={loading} className="flex flex-col items-center justify-end px-6 gap-2.5">
              <span className="text-3xl text-left font-bold w-full">
                  <span className="text-3xl font-bold">
                      {processAreasSupported?.supported}
                  </span> <span className="text-xl font-normal">/ {processAreasSupported?.total}</span>
              </span>
              <span className="text-[14px] text-left w-full">
                  PAs that this Application supports
              </span>
            </Content>
          </Block>
        )}
      </Card>
  );
};